import { Link } from "react-router";
import { useHabitStats, useHabits } from "../lib/queries";
import { describeDays, formatDuration } from "../lib/format";
import { useAuth } from "../lib/auth";

export function Habits() {
  const { today } = useAuth();
  const habits = useHabits(true);
  const stats = useHabitStats();
  const streakOf = (id: string) => stats.data?.find((s) => s.habitId === id);
  // Steps replaced by a replan end yesterday; they stay in the history, not in this list.
  const ended = (h: { endDate: string | null }) => h.endDate !== null && h.endDate < today;
  const active = (habits.data ?? []).filter((h) => !h.archivedAt && !ended(h));
  const archived = (habits.data ?? []).filter((h) => h.archivedAt || ended(h));

  return (
    <>
      <header className="page-header row">
        <h1>Hábitos</h1>
        <Link to="/habitos/nuevo" className="btn primary">+ Nuevo</Link>
      </header>
      {active.length === 0 && !habits.isPending && (
        <div className="empty card">
          <p>Empieza con algo pequeño: 10 minutos al día cuentan.</p>
        </div>
      )}
      <ul className="list">
        {active.map((h) => (
          <li key={h.id}>
            <Link to={`/habitos/${h.id}`} className="habit card" style={{ borderLeftColor: h.color }}>
              <div className="habit-time">{h.time}</div>
              <div className="habit-body">
                <div className="habit-title">{h.emoji} {h.title}</div>
                <div className="muted small">
                  {describeDays(h.daysOfWeek)} · {formatDuration(h.durationMinutes)}{h.reminder ? " · 🔔" : ""}
                </div>
                <StreakLine streak={streakOf(h.id)} />
              </div>
            </Link>
          </li>
        ))}
      </ul>
      {archived.length > 0 && (
        <>
          <h2 className="section">Archivados y terminados</h2>
          <ul className="list">
            {archived.map((h) => (
              <li key={h.id}>
                <Link to={`/habitos/${h.id}`} className="habit card archived">
                  <div className="habit-body">
                    <div className="habit-title">{h.emoji} {h.title}</div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
}

/** "🔥 4 seguidos · mejor racha 9", or nothing before the first one. */
export function StreakLine({ streak }: { streak: { current: number; best: number } | undefined }) {
  if (!streak || streak.best === 0) return null;
  return (
    <div className="small streak-line">
      {streak.current > 0 ? `🔥 ${streak.current} ${streak.current === 1 ? "vez" : "seguidos"}` : "Racha en pausa"}
      {streak.best > streak.current ? ` · mejor racha ${streak.best}` : ""}
    </div>
  );
}
